angular.module('homebot.directives')

  .directive('toggle', [function(){
    return {
      restrict: 'E',
      controllerAs: 'toggleCtrl',
      bindToController: {
        falseLabel: '@',
        trueLabel: '@',
        model: '=',
        defaultValue: '@'
      },
      scope: {},
      templateUrl: '/homes/templates/partials/toggle.html',

      controller: ['$scope', function($scope){
        var ctrl = this;

        ctrl.falseLabel = ctrl.falseLabel || 'Off';
        ctrl.trueLabel = ctrl.trueLabel || 'On';
        
      }]
    }

  }]);
